import React from "react";
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "material-ui/Table";
import Card, { CardHeader } from "material-ui/Card";
import Divider from "material-ui/Divider";
import Button from "material-ui/Button";
import Typography from "material-ui/Typography";
import CenteredProgress from "./CenteredProgress";

const AccountSettingsCard = props => {
  const { account, classes, accountSettings, loadingAccountSettings } = props;

  const hasAccountSettings = Object.keys(accountSettings).length > 0;

  const accountSettingRows = hasAccountSettings ? (
    <TableRow>
      <TableCell numeric>{accountSettings.maxInstances}</TableCell>
      <TableCell numeric>{accountSettings.maxSyncers}</TableCell>
      <TableCell numeric>{accountSettings.chargeThreshold}</TableCell>
    </TableRow>
  ) : (
    <TableRow>
      <TableCell style={{ textAlign: "center" }} colSpan="3">
        This Account doesn't have Settings yet.
      </TableCell>
    </TableRow>
  );

  const tableBody = loadingAccountSettings ? (
    <TableRow>
      <TableCell style={{ textAlign: "center" }} colSpan="3">
        <CenteredProgress />
      </TableCell>
    </TableRow>
  ) : (
    accountSettingRows
  );

  return (
    <Card>
      <CardHeader
        title={
          <Typography type="title" gutterBottom className={classes.title}>
            Resources
          </Typography>
        }
      />
      <Table>
        <TableHead>
          <TableRow>
            <TableCell numeric>Max instances</TableCell>
            <TableCell numeric>Max syncers</TableCell>
            <TableCell numeric>Charge threshold</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{tableBody}</TableBody>
      </Table>
      <Divider />
      <div className={classes.action}>
        <Button
          color="primary"
          onClick={() =>
            hasAccountSettings
              ? props.editAccountSettings(account.id)
              : props.newAccountSettings(account.id)
          }
        >
          Edit Settings
        </Button>
      </div>
    </Card>
  );
};

export default AccountSettingsCard;



// WEBPACK FOOTER //
// ./src/AccountSettingsCard.js